import React from 'react';
import type { AreaTableView } from '../../../../../services/areas/areas.service';

const TOOLBAR_GAP = 14;

type UseTableEditToolbarControllerParams = {
  table: AreaTableView;
  onRename: (name: string) => void;
};

export function useTableEditToolbarController({ table, onRename }: UseTableEditToolbarControllerParams) {
  const centerX = table.positionX + table.width / 2;

  const [nameDraft, setNameDraft] = React.useState(table.number);

  React.useEffect(() => {
    setNameDraft(table.number);
  }, [table.id, table.number]);

  const commitName = () => {
    const trimmed = nameDraft.trim();
    if (!trimmed || trimmed === table.number) {
      setNameDraft(table.number);
      return;
    }
    onRename(trimmed);
  };

  const handleNameKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.currentTarget.blur();
    } else if (event.key === 'Escape') {
      setNameDraft(table.number);
      event.currentTarget.blur();
    }
  };

  // Always render below the table.
  const anchorStyle: React.CSSProperties = {
    left: `${centerX}px`,
    top: `${table.positionY + table.height + TOOLBAR_GAP}px`,
  };

  return {
    isBelow: true,
    nameDraft,
    setNameDraft,
    commitName,
    handleNameKeyDown,
    anchorStyle,
  };
}